import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import RoundSelectButton from '../marblemath/RoundSelectButton';
import UIAssetKeys from '../UIAssetKeys';
import GameData from '../data/GameData';
import { addAnimationToSprite, PENGUIN_TALKING_ANIMATIONS } from '../AnimationManager';
import { playTitleJingle } from '../SoundManager';
import GameScreen from './GameScreen';
import MarbleDrop from './MarbleDrop';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class RoundSelectScreen extends Phaser.Scene {
  static get KEY() { return 'RoundSelectScreen'; }

  constructor() {
    super({ key: RoundSelectScreen.KEY });
  }

  init() {
    this.penguin = null;
    this.penguinShadow = null;

    this.buttonsGroup = null;
    this.buttonsBackground = null;
    this.roundSelectButtons = null;
  }

  create() {
    this.bg = this.add.image(0,0,'roundselectbackground').setOrigin(0);

    this.buttonsGroup = this.add.container();
    this.buttonsBackground = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._mm_assets_ButtonBackground, this.buttonsGroup).setOrigin(0);

    this.roundSelectButtons = [];
    const buttonLayoutData = [
      { bg: UIAssetKeys._mm_assets_RoundSelect1, x: -15, y: 275 },
      { bg: UIAssetKeys._mm_assets_RoundSelect2, x: 105, y: 478 },
      { bg: UIAssetKeys._mm_assets_RoundSelect3, x: 365, y: 478 },
      { bg: UIAssetKeys._mm_assets_RoundSelect4, x: 465, y: 275 },
      { bg: UIAssetKeys._mm_assets_RoundSelect5, x: 365, y: 53 },
      { bg: UIAssetKeys._mm_assets_RoundSelect6, x: 85, y: 25 }

    ];
    const count = buttonLayoutData.length;
    for (let i = 0; i < count; i++) {
      const item = new RoundSelectButton(this, buttonLayoutData[i].bg, i + 1);
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.levelSelectClick(item));

      item.x = buttonLayoutData[i].x;
      item.y = buttonLayoutData[i].y;
      this.roundSelectButtons.push(item);
      this.buttonsGroup.add(item);
    }

    for (let i = 0; i < count; i++) {
      // Check for an unlock
      if (i + 1 === GameData.roundReached) {
        this.roundSelectButtons[i].unlock();
        GameData.lastRoundUnlocked = GameData.roundReached;
      }
    }

    this.penguinShadow = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._mm_assets_RoundSelectPenguinShadow, this).setOrigin(0);

    this.penguin = this.add.sprite(220, 0, ABCyaPhaser.Images.DEFAULT_ATLAS);
    addAnimationToSprite(this.penguin, PENGUIN_TALKING_ANIMATIONS, 'gameIdle', true);
    addAnimationToSprite(this.penguin, PENGUIN_TALKING_ANIMATIONS, 'gameTalking', false);
    this.penguin.scaleX = -1;
    this.penguin.scaleY = 1;

    if (!GameData.playedRoundInstructions) {
      GameData.playedRoundInstructions = true;
      this.instructionsSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      this.instructionsSound.once(Phaser.Sound.Events.COMPLETE, this.stopTalking, this);
      ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._RoundSelectSound, this.instructionsSound);
      this.penguin.play('gameTalking');
    }

    this.layoutRatio();
    playTitleJingle(this);
  }

  /**
   * 
   * @param {RoundSelectButton} roundSelectButton 
   * @returns 
   */
  levelSelectClick(roundSelectButton) {
    if (roundSelectButton.isLocked) return;
    this.instructionsSound?.destroy();
    this.instructionsSound = null;
    GameData.currentRound = roundSelectButton.roundNum;
    if (roundSelectButton.roundNum <= 5) {
      this.scene.start(GameScreen.KEY);
    }
    else {
      this.scene.start(MarbleDrop.KEY);
    }
  }

  stopTalking () {
    this.penguin.play('gameIdle');
  }

  layoutRatio () {
    const scale = 1.0;
    const pBuffer = 130;
    this.buttonsGroup.scaleX = scale;
    this.buttonsGroup.scaleY = scale;
    this.buttonsGroup.x = this.scale.width - this.buttonsGroup.getBounds().width * scale - 25 * scale;
    this.buttonsGroup.y = this.scale.height / 2 - this.buttonsGroup.getBounds().height * scale / 2;
    this.penguin.y = this.scale.height - this.penguin.height - pBuffer;
    this.penguinShadow.x = this.penguin.x - this.penguin.width - 85;
    this.penguinShadow.y = this.penguin.y + this.penguin.height - 46;
  }
}